import { render, staticRenderFns } from "./DropDownNotificationComponent.vue?vue&type=template&id=060e4c91&scoped=true&"
import script from "./DropDownNotificationComponent.vue?vue&type=script&lang=js&"
export * from "./DropDownNotificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./DropDownNotificationComponent.vue?vue&type=style&index=0&id=060e4c91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060e4c91",
  null
  
)

export default component.exports